import { Text } from "@clipboard-health/ui-react";
import { Card, CardHeader } from "@mui/material";

import { useShiftCardContext } from "./useShiftCard";

export function ShiftBoardEtaMessage({ ...style }: React.CSSProperties) {
  const { message } = useShiftCardContext();

  if (!message) {
    return null;
  }

  return (
    <Card variant="outlined" sx={{ backgroundColor: "#FAFAFA", ...style }}>
      <CardHeader sx={{ padding: 1 }} title={<Text>{message}</Text>} />
    </Card>
  );
}
